module.exports = __webpack_public_path__ + "img/Small_lisae.1057d91d.png";